import { OptionProps, components } from 'react-select';
import { TipPlacement, Tooltip } from 'ui/tooltip';
import {
  LabelWithoutCheckbox,
  SecondaryText,
  SelectOptionInnerWrapper,
  SelectOptionValue,
  Description,
} from './Select.styles';
import { BaseOption } from './types';

export const SingleSelectInputOption = ({
  isSelected,
  isDisabled,
  children,
  data,
  ...props
}: OptionProps<BaseOption>) => {
  return (
    <components.Option {...props} data={data} isDisabled={isDisabled} isSelected={isSelected}>
      <SelectOptionValue data-test={`single-select-option-${data.value}`}>
        <SelectOptionInnerWrapper>
          <Tooltip
            isEnabled={!!data?.tooltipContent}
            placement={TipPlacement.Left}
            tooltipContent={data?.tooltipContent}
          >
            <LabelWithoutCheckbox>{children}</LabelWithoutCheckbox>
          </Tooltip>
          {data.Suffix ? (
            <SecondaryText data-test={`${data.value}-suffix`}>{data.Suffix}</SecondaryText>
          ) : null}
        </SelectOptionInnerWrapper>
        {data.description && <Description>{data.description}</Description>}
      </SelectOptionValue>
    </components.Option>
  );
};
